import {message} from '@sail/intl';

export const requiredMsg = message({
  id: '@sail/ui.form.validation.required',
  description: 'Error message when a required field is empty',
  defaultMessage: 'This field is required',
});

export const minLengthMsg = message<{value: number}>({
  id: '@sail/ui.form.validation.minLength',
  description: 'Error message when a field has too few characters',
  defaultMessage:
    '{value, plural, one{Must be at least # character} other{Must be at least # characters}}',
});

export const maxLengthMsg = message<{value: number}>({
  id: '@sail/ui.form.validation.maxLength',
  description: 'Error message when a field has too many characters',
  defaultMessage:
    '{value, plural, one{Must be at most # character} other{Must be at most # characters}}',
});

export const minMsg = message<{value: number}>({
  id: '@sail/ui.form.validation.min',
  description: 'Error message when a numeric value is too small',
  defaultMessage: 'Must be at least {value}',
});

export const maxMsg = message<{value: number}>({
  id: '@sail/ui.form.validation.max',
  description: 'Error message when a numeric value is too large',
  defaultMessage: 'Must be at most {value}',
});

export const invalidFormatMsg = message({
  id: '@sail/ui.form.validation.invalidFormat',
  description: 'Error message when a field does not match the expected pattern',
  defaultMessage: 'Invalid format',
});

